var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgTrial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1277.001,
    height: 591.836,
    viewBox: "0 0 1277.001 591.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14670",
    "data-name": "Group 14670",
    transform: "translate(-46.56 -119.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7",
    "data-name": "Rounded Rectangle 7",
    d: "M528.4,38.806l7.91-3.668a1.982,1.982,0,0,1,1.667,3.6l-7.91,3.668a1.982,1.982,0,0,1-1.667-3.6Z",
    transform: "translate(15.417 84.963)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    "data-name": "Rounded Rectangle 7 copy",
    d: "M28.292,351.255l7.91-3.669a1.982,1.982,0,0,1,1.667,3.6l-7.91,3.669a1.982,1.982,0,0,1-1.667-3.6Z",
    transform: "translate(19.417 106.963)",
    fill: "#1c97ce",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_9",
    "data-name": "Rounded Rectangle 9",
    d: "M209.782,66.661l-3.6-4.221a1.982,1.982,0,1,1,3.013-2.576l1.983,2.323,3.2-7.194a1.817,1.817,0,0,1,2.129-1.251,1.981,1.981,0,0,1,2.2.571l3.6,4.221a1.982,1.982,0,1,1-3.013,2.576l-2.3-2.7-3.145,7.07a1.871,1.871,0,0,1-1.02,1.146,1.981,1.981,0,0,1-3.041.033Z",
    transform: "translate(19.417 106.963)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_9-2",
    "data-name": "Rounded Rectangle 9",
    d: "M209.782,66.661l-3.6-4.221a1.982,1.982,0,1,1,3.013-2.576l1.983,2.323,3.2-7.194a1.817,1.817,0,0,1,2.129-1.251,1.981,1.981,0,0,1,2.2.571l3.6,4.221a1.982,1.982,0,1,1-3.013,2.576l-2.3-2.7-3.145,7.07a1.871,1.871,0,0,1-1.02,1.146,1.981,1.981,0,0,1-3.041.033Z",
    transform: "translate(19.417 533.963)",
    fill: "#1c97ce",
    opacity: 0.199
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_9-3",
    "data-name": "Rounded Rectangle 9",
    d: "M209.782,66.661l-3.6-4.221a1.982,1.982,0,1,1,3.013-2.576l1.983,2.323,3.2-7.194a1.817,1.817,0,0,1,2.129-1.251,1.981,1.981,0,0,1,2.2.571l3.6,4.221a1.982,1.982,0,1,1-3.013,2.576l-2.3-2.7-3.145,7.07a1.871,1.871,0,0,1-1.02,1.146,1.981,1.981,0,0,1-3.041.033Z",
    transform: "translate(919.434 644.396)",
    fill: "#1c97ce",
    opacity: 0.199
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_9-4",
    "data-name": "Rounded Rectangle 9",
    d: "M209.782,66.661l-3.6-4.221a1.982,1.982,0,1,1,3.013-2.576l1.983,2.323,3.2-7.194a1.817,1.817,0,0,1,2.129-1.251,1.981,1.981,0,0,1,2.2.571l3.6,4.221a1.982,1.982,0,1,1-3.013,2.576l-2.3-2.7-3.145,7.07a1.871,1.871,0,0,1-1.02,1.146,1.981,1.981,0,0,1-3.041.033Z",
    transform: "translate(1086.417 243.382)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_9_copy_3",
    "data-name": "Rounded Rectangle 9 copy 3",
    d: "M765.151,339.58a1.981,1.981,0,0,1,2.793.22l3.6,4.221a1.982,1.982,0,1,1-3.013,2.575l-3.6-4.221A1.983,1.983,0,0,1,765.151,339.58Z",
    transform: "translate(20.417 201.963)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_9_copy_3-2",
    "data-name": "Rounded Rectangle 9 copy 3",
    d: "M765.151,339.58a1.981,1.981,0,0,1,2.793.22l3.6,4.221a1.982,1.982,0,1,1-3.013,2.575l-3.6-4.221A1.983,1.983,0,0,1,765.151,339.58Z",
    transform: "translate(-435.583 357.592)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_8",
    "data-name": "Rounded Rectangle 8",
    d: "M28.99,152.543l10.772,5.033a1.189,1.189,0,0,1-1.006,2.156L27.984,154.7a1.189,1.189,0,0,1,1.006-2.156Z",
    transform: "translate(19.417 106.963)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1",
    "data-name": "Shape 1",
    d: "M746.875,99.264l7.55,1.73a.5.5,0,0,0,.577-.65c-.1-.334-2.061-7.012-2.229-7.582a.474.474,0,0,0-.818-.187c-.291.316-4.987,5.491-5.317,5.868A.494.494,0,0,0,746.875,99.264Z",
    transform: "translate(44.936 131.446)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy",
    "data-name": "Shape 1 copy",
    d: "M298.257,140.506l8.787-11.422a.921.921,0,0,0-.642-1.479c-.636-.1-13.376-1.948-14.464-2.1a.885.885,0,0,0-.952,1.237c.3.737,5.332,12.684,5.708,13.534A.911.911,0,0,0,298.257,140.506Z",
    transform: "translate(24.417 87.3)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-2",
    "data-name": "Shape 1 copy",
    d: "M295.777,135.436l5.82-7.565a.61.61,0,0,0-.425-.98c-.421-.063-8.86-1.29-9.581-1.394a.586.586,0,0,0-.63.819c.2.488,3.532,8.4,3.781,8.965A.6.6,0,0,0,295.777,135.436Z",
    transform: "translate(336.929 549.793)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-3",
    "data-name": "Shape 1 copy",
    d: "M298.257,140.506l8.787-11.422a.921.921,0,0,0-.642-1.479c-.636-.1-13.376-1.948-14.464-2.1a.885.885,0,0,0-.952,1.237c.3.737,5.332,12.684,5.708,13.534A.911.911,0,0,0,298.257,140.506Z",
    transform: "translate(694.765 435.3)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-4",
    "data-name": "Shape 1 copy",
    d: "M298.257,140.506l8.787-11.422a.921.921,0,0,0-.642-1.479c-.636-.1-13.376-1.948-14.464-2.1a.885.885,0,0,0-.952,1.237c.3.737,5.332,12.684,5.708,13.534A.911.911,0,0,0,298.257,140.506Z",
    transform: "translate(842.765 71.935)",
    fill: "#1c97ce",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_8-2",
    "data-name": "Rounded Rectangle 8",
    d: "M29.146,152.553l11.766,5.5a1.3,1.3,0,0,1-1.1,2.355l-11.766-5.5a1.3,1.3,0,0,1,1.1-2.354Z",
    transform: "translate(1281.9 -13.614)",
    fill: "#1c97ce",
    opacity: 0.131
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 4.77,
    cy: 4.77,
    r: 4.77,
    transform: "translate(71.517 143.743)",
    fill: "#1c97ce",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 4.77,
    cy: 4.77,
    r: 4.77,
    transform: "translate(93.517 665.743)",
    fill: "#1c97ce",
    opacity: 0.131
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-3",
    "data-name": "Ellipse 4",
    cx: 4.77,
    cy: 4.77,
    r: 4.77,
    transform: "translate(496.517 571.743)",
    fill: "#1c97ce",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-4",
    "data-name": "Ellipse 4",
    cx: 4.77,
    cy: 4.77,
    r: 4.77,
    transform: "translate(1266.517 589.68)",
    fill: "#1c97ce",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4_copy",
    "data-name": "Ellipse 4 copy",
    cx: 3.17,
    cy: 3.17,
    r: 3.17,
    transform: "translate(965.707 140.573)",
    fill: "#1c97ce",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTrial);
export default __webpack_public_path__ + "static/media/bg_trial.154b505a4320acba5f3c95d9d9afb09a.svg";
export { ForwardRef as ReactComponent };